/**
 * External / social link configuration.
 *
 * Confirmed real KETIX3D URLs are hardcoded as defaults below — they are
 * public information, not secrets, and Prince has confirmed them directly.
 * Environment variables can still override any of these per-deployment
 * (e.g. a staging build), but nothing here is fabricated.
 */

function readPublicEnv(name: string): string | null {
  const value = import.meta.env[name as keyof ImportMetaEnv] as string | undefined;
  return value && value.trim().length > 0 ? value.trim() : null;
}

const CONFIRMED_YOUTUBE = 'https://www.youtube.com/@ketix3d';
const CONFIRMED_TWITTER = 'https://x.com/KETIX3D';
const CONFIRMED_GOOGLE_PLAY_CNC = 'https://play.google.com/store/apps/details?id=com.ketix3d.cnc';
/**
 * The ONLY official KETIX3D website/business/contact email, per policy.
 * Do not add any other email constant here — a second email invites the
 * two being mixed up again on some page.
 */
const CONFIRMED_BUSINESS_EMAIL = 'ketix3dteam@gmail.com';

export const externalLinks = {
  youtube: readPublicEnv('VITE_SOCIAL_YOUTUBE_URL') ?? CONFIRMED_YOUTUBE,
  twitter: readPublicEnv('VITE_SOCIAL_TWITTER_URL') ?? CONFIRMED_TWITTER,
  // Not yet confirmed — stays null until Prince provides a real URL.
  instagram: readPublicEnv('VITE_SOCIAL_INSTAGRAM_URL'),
  linkedin: readPublicEnv('VITE_SOCIAL_LINKEDIN_URL'),
  googlePlayCnc: readPublicEnv('VITE_GOOGLE_PLAY_CNC_URL') ?? CONFIRMED_GOOGLE_PLAY_CNC,
} as const;

/** The single official website/business contact email — see policy note above. */
export const contactEmails = {
  business: readPublicEnv('VITE_CONTACT_EMAIL') ?? CONFIRMED_BUSINESS_EMAIL,
} as const;

export const siteUrl = readPublicEnv('VITE_SITE_URL') ?? 'https://ketix3d.com';

/** True only when at least one confirmed social link has been configured. */
export const hasAnySocialLink = Object.values(externalLinks).some((v) => v !== null);

